module.exports = __webpack_public_path__ + "img/log_pic.1b9e3f81.png";